"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var Line = function Line() {
  return null;
};

Line.defaultProps = {
  dataKey: 'value',
  dataUnit: '',
  strokeColor: 'color-coldplay-fountain',
  legendType: 'square',
  type: 'monotone',
  isAnimationActive: true
};
var _default = Line;
exports.default = _default;